const UNVERIFIED_COMPANY_RULES = {
  maxBookings: 10,
};

export default UNVERIFIED_COMPANY_RULES;
